import { Store } from "redux";

import WebSpeechAPI from "./WebSpeechAPI";
import CrOSWebSpeechAPI from "./CrOSWebSpeechAPI";

// TODO: rework ASAP
export default function createSpeech(store: Store) {
  const { appVersion } = navigator;

  return appVersion.indexOf("CrOS") !== -1
    ? new CrOSWebSpeechAPI({ store })
    : new WebSpeechAPI({ store });
}
